<template>
  <div class="DbSettings">
    <div>
      <strong>پایگاه داده کنترل کارکرد</strong>
      <v-divider class="my-2"></v-divider>
      <v-row>
        <v-col cols="6" sm="4" md="3" lg="2">آدرس سرور :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field hide-details solo dense v-model="config.ServerName"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">نام پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field hide-details solo dense v-model="config.DBName"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">نام کاربری پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field hide-details solo dense v-model="config.DBUserName"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">رمز ورود پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field
            hide-details
            solo
            dense
            v-model="config.DBPassWord"
            :append-icon="showDBPassWord ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showDBPassWord ? 'text' : 'password'"
            @click:append="showDBPassWord = !showDBPassWord"
        /></v-col>
      </v-row>

      <strong class="mt-3">پایگاه داده تصاویر</strong>
      <v-divider class="my-2"></v-divider>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">نام پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field hide-details solo dense v-model="config.WinPrsDBName"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">نام کاربری پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field
            hide-details
            solo
            dense
            v-model="config.WinPrsUserName"
        /></v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">رمز ورود پایگاه داده :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field
            hide-details
            solo
            dense
            v-model="config.WinPrsPassword"
            :append-icon="showWinPrsPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showWinPrsPassword ? 'text' : 'password'"
            @click:append="showWinPrsPassword = !showWinPrsPassword"
        /></v-col>
      </v-row>

      <strong class="mt-3">برای ذخیره تغییرات رمز عبور را وارد نمایید.</strong>
      <v-divider class="my-2"></v-divider>

      <v-row class="mt-1">
        <v-col cols="6" sm="4" md="3" lg="2">رمز ورود مدیر :</v-col>
        <v-col cols="6" sm="4"
          ><v-text-field
            hide-details
            solo
            dense
            v-model="config.adminpass"
            :append-icon="showAdminPass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showAdminPass ? 'text' : 'password'"
            @click:append="showAdminPass = !showAdminPass"
        /></v-col>
      </v-row>

      <div class="d-flex mt-2">
        <v-spacer />
        <v-btn @click="btnConfigDB_click" color="primary"
          >بروز رسانی اطلاعات پایگاه داده</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
export default {
  props: { config: Object },
  data() {
    return {
      txtAdminPasswordDB: "",
      showDBPassWord: false,
      showWinPrsPassword: false,
      showAdminPass: false,
    };
  },
  mounted() {},
  methods: {
    btnConfigDB_click() {
      if (!this.config.adminpass) {
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: "رمز ورود مدیر را وارد نمایید",
        });
        return;
      }
      var saveConfigParams = this.config;
      this.$store
        .dispatch("saveConfig", { saveConfigParams })
        .then((result) => {
          ////console.log(result);
          if (result.type === ResultType.success && result.data) {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("operationSuccess"),
            });
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || this.$t("operationFailed"),
            });
          }
        });
    },
  },
};
</script>

<style>
</style>